import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { RolesStore } from '@fry/lib/roles';
import { ListService } from '@fry/lib/list';
import { RolesSearch } from '@fry/components/roles/roles.search';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { of } from 'rxjs';


@Component({
    selector: 'app-role-list',
    templateUrl: './role-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoleListComponent implements OnInit, OnDestroy {

  public items = this.list.items;
  public actions: EASLinkAction[] = [{
    type: 'link',
    label: $localize `New role`,
    condition: () => {
      return of(true);
    },
    link: of(['add']),
    color: 'primary',
  }];

  constructor(
    private roles: RolesStore,
    private search: RolesSearch,
    public list: ListService
  ) { }

  ngOnInit() {
    this.list.setupWith(this.roles, this.search).subscribe();
    this.list.searchModel = {
      filter: {},
      sort: { sort_on: 'title', sort_order: 'asc' }
    };
  }

  ngOnDestroy() {
  }

}
